var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { position, width, maxWidth, space, fontSize, color, lineHeight, display, flexDirection, alignItems, flex, borderRadius, themeGet, } from 'styled-system';
import { themeHeight, themeMaxHeight, themeMaxWidth, themeWidth, } from '../../common/theme/theme';
import { Button } from '../../common/components/Button';
import { getTrackerProps } from '../../common/tracking/getTrackerProps';
import { LocaleProviderPropTypes, withLocale, } from '../../common/providers/LocaleProvider';
import subscribeIcon from '../../common/assets/icons/subscribe.svg';
var NewsletterFormContainer = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), position, display, flexDirection, alignItems, flex, width, maxWidth, space);
NewsletterFormContainer.defaultProps = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: ['center', null, 'normal'],
    flex: '1 1 auto',
    width: '100%',
    maxWidth: ['428px', null, '512px'],
    m: '0 auto',
};
var NewsletterErrorLabel = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), display, fontSize, lineHeight, color);
NewsletterErrorLabel.defaultProps = {
    display: 'block',
    fontSize: 2,
    lineHeight: 3,
    color: 'sale',
};
var NewsletterInputContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, alignItems, width);
NewsletterInputContainer.defaultProps = {
    display: 'flex',
    width: '100%',
    alignItems: ['center', null, 'normal'],
};
var NewsletterLabel = styled.label(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 383px;\n  height: 40px;\n"], ["\n  width: 100%;\n  max-width: 383px;\n  height: 40px;\n"])));
var NewsletterInput = styled.input(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  width: 100%;\n  border: none;\n  border: 1px solid ", ";\n  border-right: none;\n  box-sizing: border-box;\n\n  &:active,\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &[type='email'] {\n    -webkit-appearance: none;\n    height: 100% !important;\n\n    &:invalid {\n      box-shadow: none !important;\n    }\n\n    &::-ms-clear {\n      display: none;\n    }\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      -webkit-appearance: none;\n    }\n  }\n\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  width: 100%;\n  border: none;\n  border: 1px solid ", ";\n  border-right: none;\n  box-sizing: border-box;\n\n  &:active,\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &[type='email'] {\n    -webkit-appearance: none;\n    height: 100% !important;\n\n    &:invalid {\n      box-shadow: none !important;\n    }\n\n    &::-ms-clear {\n      display: none;\n    }\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      -webkit-appearance: none;\n    }\n  }\n\n  ", ";\n  ", ";\n"])), fontSize, space, borderRadius, themeGet('colors.gray.5'), themeGet('colors.gray.10'), themeGet('colors.gray.5'), function (props) { return (props.hasError ? "border-color: #db2916 !important" : ''); }, function (props) { return (!props.theme.isHome24 ? "border-radius: 0" : ''); });
NewsletterInput.defaultProps = {
    fontSize: 4,
    mt: 0,
    mb: [3, null, 0],
    p: 2,
    borderRadius: '3px 0 0 3px',
};
var NewsletterSubmitButton = styled(Button)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  box-shadow: none;\n  outline: none;\n  white-space: nowrap;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  box-shadow: none;\n  outline: none;\n  white-space: nowrap;\n"])), width, space, borderRadius);
NewsletterSubmitButton.defaultProps = __assign({}, Button.defaultProps, { borderRadius: '0 3px 3px 0', width: ['50px', '128px'], py: [1, 2] });
var NewsletterSubmitButtonText = styled.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, fontSize);
NewsletterSubmitButtonText.defaultProps = {
    display: ['none', 'block'],
    fontSize: 4,
};
var SubscribeIcon = styled.img(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), display, themeWidth, themeMaxWidth, themeHeight, themeMaxHeight);
SubscribeIcon.defaultProps = {
    src: subscribeIcon,
    display: ['block', 'none'],
    themeWidth: 5,
    themeMaxWidth: 5,
    themeHeight: 5,
    themeMaxHeight: 5,
};
var NewsletterForm = /** @class */ (function (_super) {
    __extends(NewsletterForm, _super);
    function NewsletterForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            inputValue: '',
            hasError: false,
            errorMessage: '',
        };
        _this.onChangeInput = _this.onChangeInput.bind(_this);
        _this.onInvalidForm = _this.onInvalidForm.bind(_this);
        return _this;
    }
    NewsletterForm.prototype.onChangeInput = function (event) {
        this.setState({
            inputValue: event.target.value,
        });
    };
    NewsletterForm.prototype.onInvalidForm = function (event) {
        event.preventDefault();
        var _a = event.target.validity, valueMissing = _a.valueMissing, typeMismatch = _a.typeMismatch;
        this.setState({
            hasError: true,
            errorMessage: valueMissing
                ? 'h24_newsletter_email_required_error'
                : typeMismatch
                    ? 'h24_newsletter_invalid_email_error'
                    : '',
        });
    };
    NewsletterForm.prototype.render = function () {
        var _a = this.props, l10n = _a.l10n, formAction = _a.formAction;
        var _b = this.state, inputValue = _b.inputValue, hasError = _b.hasError, errorMessage = _b.errorMessage;
        var action = l10n.prefix(formAction);
        return (React.createElement(NewsletterFormContainer, __assign({}, getTrackerProps({
            action: action,
            method: 'post',
            onInvalid: this.onInvalidForm,
            onClick: function (event) {
                event.nativeEvent.trackingPreventDefault = true;
            },
            'data-testid': 'newsletter-form',
            'data-valid': !hasError,
        }, {
            event: 'footerTracking',
            eventData: {
                placement: 'newsletterSignup',
                targetUrl: action,
            },
        })),
            errorMessage && (React.createElement(NewsletterErrorLabel, { "data-testid": "newsletter-form-error-label", htmlFor: "newsletter-input" }, l10n.t(errorMessage))),
            React.createElement(NewsletterInputContainer, null,
                React.createElement(NewsletterLabel, { htmlFor: "newsletter-input", "data-testid": "newsletter-form-label" },
                    React.createElement(NewsletterInput, { required: true, value: inputValue, hasError: hasError, type: "email", name: "email", id: "newsletter-input", "data-testid": "newsletter-form-input", "aria-label": l10n.t('h24_newsletter_input_placeholder'), placeholder: l10n.t('h24_newsletter_input_placeholder'), onChange: this.onChangeInput })),
                React.createElement(NewsletterSubmitButton, { type: "submit", "data-testid": "newsletter-form-submit-button", "aria-labelledby": "newsletter-button-label" },
                    React.createElement(SubscribeIcon, null),
                    React.createElement(NewsletterSubmitButtonText, { id: "newsletter-button-label", "data-testid": "newsletter-button-label" }, l10n.t('h24_newsletter_submit_button'))))));
    };
    NewsletterForm.propTypes = {
        /** Locale context. */
        l10n: LocaleProviderPropTypes,
        /** Form action. */
        formAction: PropTypes.string,
    };
    NewsletterForm.defaultProps = {
        formAction: '/newsletter',
    };
    return NewsletterForm;
}(React.Component));
export default withLocale(NewsletterForm);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
